import { render, staticRenderFns } from "./AirportTransferServiceBanner.vue?vue&type=template&id=4c7bc4c9&"
import script from "./AirportTransferServiceBanner.vue?vue&type=script&lang=js&"
export * from "./AirportTransferServiceBanner.vue?vue&type=script&lang=js&"
import style0 from "./AirportTransferServiceBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports